// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".treemap svg[data-v-ef334c50] {\n  font: 10px sans-serif;\n}\n.legend[data-v-ef334c50] {\n  white-space: nowrap;\n  cursor: pointer;\n}\n.selected-legend[data-v-ef334c50] {\n  text-decoration: underline;\n  -webkit-text-decoration-color: red;\n          text-decoration-color: red;\n  text-decoration-thickness: 2px;\n}", ""]);
// Exports
module.exports = exports;
